import { TrustedPartner } from '../types';
import { TrustedPartnersRepository } from './TrustedPartnersRepository';
import { partnerApi } from '../../../../services/api/partnerApi';


export class ApiTrustedPartnersRepository implements TrustedPartnersRepository {
  public async getAllPartners(): Promise<TrustedPartner[]> {
    try {      
      const backendPartners = await partnerApi.getAllPartners();
      console.log({backendPartners})
      return backendPartners.map(partner => ({
        id: partner.partnerId,
        //@ts-ignore
        category: partner.category,
        //@ts-ignore 
        logo: partner.logo || '/default-logo.png',
        //@ts-ignore
        name: partner.name,
        //@ts-ignore
        phone: partner.phone,
        //@ts-ignore
        email: partner.email,
        //@ts-ignore
        link: partner.link || '#'
      }));
    } catch (error) {
      console.error('ApiTrustedPartnersRepository: Error! , error')
      throw new Error(`Failed to fetch partners: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}


